
<ngx-spinner></ngx-spinner>
<app-header></app-header>
<div class="container-body">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
